/**
 * Last-known `/api/v1/operations/my-features` payload for Message Centre UI
 * (encrypted meta on `messages` domain) — hydrates before the network round-trip.
 */
import messagesStore from '@/lib/offline/messagesStore';

export interface CachedMessagingFeatureSettingsPayload {
  /** Raw API `feature_settings` object */
  feature_settings: Record<string, unknown>;
  cachedAt: string;
}

export async function readCachedMessagingFeatureSettings(
  clientId: number,
): Promise<CachedMessagingFeatureSettingsPayload | null> {
  if (!clientId) {
    return null;
  }
  return messagesStore.getMeta<CachedMessagingFeatureSettingsPayload>(
    clientId,
    'operations_my_features',
  );
}

export async function writeCachedMessagingFeatureSettings(
  clientId: number,
  featureSettings: Record<string, unknown>,
): Promise<void> {
  if (!clientId) {
    return;
  }
  await messagesStore.setMeta(clientId, 'operations_my_features', {
    feature_settings: featureSettings,
    cachedAt: new Date().toISOString(),
  });
}
